import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Select } from 'primeng/select';
import { TranslocoService, TranslocoModule } from '@jsverse/transloco';

interface Language {
  name: string;
  key: string;
}

@Component({
  selector: 'app-language-selector',
  standalone: true,
  imports: [Select, TranslocoModule, FormsModule],
  templateUrl: './language-selector.component.html',
  styleUrl: './language-selector.component.scss',
})
export class LanguageSelectorComponent {
  private translocoService = inject(TranslocoService);

  languages: Language[] = [
    { name: 'English', key: 'en' },
    { name: 'Français', key: 'fr' },
    { name: 'Nederlands', key: 'nl' },
    // { name: 'Deutsch', key: 'de' }, // Not ready yet
  ];

  selectedLanguage: Language = { name: 'English', key: 'en' };

  constructor() {
    const currentLang = this.translocoService.getActiveLang();
    const found = this.languages.find((lang) => lang.key === currentLang);
    if (found) {
      this.selectedLanguage = found;
    }
  }

  onLanguageChange(event: { value: Language }): void {
    if (event.value) {
      this.translocoService.setActiveLang(event.value.key);
      localStorage.setItem('selectedLanguage', event.value.key);
      this.selectedLanguage = event.value;
    }
  }
}
